/**
 * Modelos de autorización (Módulo → Opción → Acción).
 * El backend define el modelo; aquí solo las formas que consume el frontend.
 */

export type ActionCode =
  | 'CREATE'
  | 'EDIT'
  | 'ACTIVATE'
  | 'CONSULT'
  | 'DOWNLOAD'
  | 'AVAILABLE';

export type ChannelType = 'WEB' | 'MOBILE';

export interface AuthModule {
  id: number;
  code: string;
  name: string;
  channel_type: ChannelType;
  is_active: boolean;
  sort_order: number;
}

export interface AuthOption {
  id: number;
  module_id: number;
  code: string;
  name: string;
  /** Code estable que usan el guard y la directiva. */
  reference_code: string;
  channel_type: ChannelType;
  is_active: boolean;
  sort_order: number;
}

export interface AuthAction {
  id: number;
  code: ActionCode;
  name: string;
}

export interface AuthLevel {
  id: number;
  code: string;
  name: string;
  hierarchy_order: number;
  is_active: boolean;
}

export interface Role {
  id: number;
  code: string;
  name: string;
  channel_type: ChannelType;
  level_id: number;
  is_active: boolean;
}

export interface RolePermission {
  id?: number;
  role_id: number;
  option_id: number;
  action_id: number;
  is_allowed: boolean;
}

/** Permisos efectivos del usuario: reference_code → acciones permitidas. */
export type EffectivePermissions = Record<string, ActionCode[]>;

/**
 * Genera el `code` del rol como el backend: MAYÚSCULAS, sin tildes ni símbolos,
 * separadores → "_", sin "_" al inicio/fin. Ej: 'Líder, mercaderista!' → 'LIDER_MERCADERISTA'.
 */
export function slugifyRoleCode(value: string | null | undefined): string {
  return (value || '')
    .trim()
    .toUpperCase()
    .normalize('NFD').replace(/[̀-ͯ]/g, '')
    .replace(/[^A-Z0-9]+/g, '_')
    .replace(/^_+|_+$/g, '');
}
